import * as actionTypes from './action_types';

export const startAssessment = () => ({
    type: actionTypes.START,
});
export const markOnbording = () => ({
    type: actionTypes.CHECK_ONBORDING,
});

export const updatePersonalForm = (key: string, value: any) => ({
    type: actionTypes.UPDATE_PERSONAL_FORM,
    payload: { key, value },
});

export const updateForm = (key: string, value: any) => ({
    type: actionTypes.UPDATE_FORM,
    payload: { key, value },
});

export const markSuicideAttempt = (value: any) => ({
    type: actionTypes.SET_SUICIDE_ATTEMPT,
    payload: value,
});

export const markSuicideAttemptWhen = (value: any) => ({
    type: actionTypes.SET_SUICIDE_ATTEMPT_WHEN,
    payload: value,
});

export const markPriorTreatment = (value: any) => ({
    type: actionTypes.SET_PRIOR_TREATMENT,
    payload: value,
});

export const reset = () => ({
    type: actionTypes.RESET,
});
